import styled from 'styled-components'

export const Preview = styled.div`
  display: flex;
  align-items: center;

  .ant-spin-container {
    display: flex;
    align-items: center;
  }

  button {
    height: 40px;
    border-radius: 8px;
    padding: 8px 12px;
    border: none;
    font-weight: bold;
    font-size: 14px;
    color: #0085ff !important;
    background-color: #e7f3fe !important;
    z-index: 1;
    &:hover {
      opacity: 0.8;
    }
  }
`

export const Wrapper = styled.div`
  .ant-card-body {
    padding: 0;
    padding-top: 0;
  }
  ._38ARV > .ant-card-body {
    padding-top: 0;
  }
  .editable {
    .rankmiTemplates-languageSelector {
      display: none;
    }
    > .ant-tabs {
      top: 0 !important;
      margin-bottom: 0 !important;
    }

    > .ant-tabs .ant-tabs-content {
      margin-bottom: 0;
    }

    > .ant-tabs .ant-tabs-tabpane {
      padding-bottom: 0;
    }

    > .ant-tabs ._12NlZ {
      margin-bottom: 0;
    }

    > .ant-tabs + div {
      display: block;
      margin-top: 24px !important;

      .ant-divider,
      .ant-divider-horizontal {
        display: none !important;
      }

      > .ant-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        min-height: 40px;
        margin: 0 !important;
      }

      #lms-certificate-template-preview-slot {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0;
      }

      > .ant-row > .ant-col:nth-child(2),
      > .ant-row > .ant-col:nth-child(3) {
        display: none !important;
      }

      /* Paquete renderiza Guardar y luego Cancelar; invertimos a Cancelar | Guardar */
      > .ant-row > .ant-col:last-child {
        display: flex !important;
        flex: 0 0 auto;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        float: none !important;
        width: auto !important;
        max-width: none;
        margin-left: auto;
        padding: 0 !important;
      }

      button {
        float: none !important;
        margin-left: 0 !important;
        border-radius: 8px;
        padding: 8px 12px;
        border: none;
        font-weight: bold;
        font-size: 14px;
        &:hover {
          opacity: 0.7;
        }
      }
      .rkm-btn-secondary {
        color: #4c4c4c;
        background-color: #f0f0f0;
      }
      .rkm-btn-success {
        float: left;
        margin-left: 0px;
        color: #0085ff;
        background-color: #e7f3fe;
        display: none;
      }
      .ant-btn-primary {
        color: white;
        background-color: #0085ff;
      }
    }
    > .ant-row {
      > .ant-col-12 {
        display: none;
      }
      > .ant-col-12 + .ant-col-12 {
        display: block;
      }
    }
  }

  #card {
    border-color: white;
    padding-right: 6px !important;
    padding-bottom: 0px !important;

    > .ant-btn {
      border: none;
      svg {
        top: 1px;
        left: -5px;
      }
    }
    > .ant-btn + p {
      position: relative;
      top: 2px;
    }

    /* Contenedor del listado: chip (tabla) + botón (paquete) en una misma fila */
    > div {
      position: relative;
    }

    /* Oculta el contenedor vacío del alert inicial del paquete */
    > div > div:first-child:empty {
      display: none;
      margin: 0;
    }

    /* Botón "Nueva plantilla" alineado a la derecha de la fila del chip */
    > div > div:has(> h1) {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      min-height: 40px;
      z-index: 1;
    }

    /* Listado: oculta h1 "Plantillas" (el título vive en CertificateTemplatesTabs) */
    > div > div > h1 {
      display: none;
    }

    /* Crear / editar: oculta h1 "General" y "Modo edición" (queda el breadcrumb del paquete) */
    > div:has(> .editable) > h1 {
      display: none;
    }

    /* Botón primario según Figma (23488:11752); el texto lo define rankmi-templates */
    > div > div > h1 + button,
    > div > div > .ant-btn-primary {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-wrap: nowrap;
      gap: 4px;
      float: none;
      top: auto;
      position: static;
      height: auto !important;
      min-height: 40px;
      margin: 0 !important;
      padding: 12px !important;
      border: none !important;
      border-radius: 8px !important;
      background-color: #2684ff !important;
      box-shadow: none !important;
      text-shadow: none !important;
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 16px !important;
      color: #fff !important;
      white-space: nowrap;
      z-index: 1;

      &:hover,
      &:focus,
      &:active {
        background-color: #0069f2 !important;
        color: #fff !important;
        border: none !important;
        box-shadow: none !important;
        text-shadow: none !important;
      }

      /* Ant Design fuerza inline-block y vertical-align en iconos */
      > i,
      > span,
      > .anticon {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0;
        float: none !important;
        position: static !important;
        top: auto !important;
        margin: 0 !important;
        line-height: 0 !important;
        vertical-align: middle !important;
      }

      .anticon.anticon-plus {
        width: 16px;
        height: 16px;
        color: #fff !important;

        svg {
          display: block;
          width: 14px !important;
          height: 14px !important;
          margin: 0 !important;
          /* Compensa el viewBox del icono de Ant Design vs. el plus de Figma */
          transform: translateY(1px);
        }
      }
    }

    > div > .rankmiTable-container {
      margin-top: 0;
    }

    /* Fila del chip de total: alineación vertical con el botón y 16px hasta la tabla */
    > div > .rankmiTable-container > .ant-row.ant-row-flex-end:first-of-type,
    > div > .rankmiTable-container > .ant-row:first-of-type {
      align-items: center !important;
      justify-content: flex-start !important;
      margin-bottom: 16px !important;
      min-height: 40px;
      padding-right: 200px;
    }

    > div
      > .rankmiTable-container
      > .ant-row:first-of-type
      > .ant-col:not(:has(.rankmiTable-rowsCount)) {
      display: none !important;
    }

    > div
      > .rankmiTable-container
      > .ant-row:first-of-type
      > .ant-col:has(.rankmiTable-rowsCount) {
      width: auto !important;
      max-width: none !important;
      flex: 0 0 auto !important;
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
      padding-left: 0 !important;
      justify-content: flex-start !important;
    }

    > div
      > .rankmiTable-container
      > .ant-row:first-of-type
      > .ant-col:has(.rankmiTable-rowsCount)
      > div {
      justify-content: flex-start !important;
    }

    > div > .rankmiTable-container > .ant-row:first-of-type .mb-2 {
      margin-bottom: 0 !important;
    }

    > div > .rankmiTable-container .rankmiTable-rowsCount {
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 0;
    }

    > div > div > div > div > div > .ant-table-wrapper {
      margin-top: 0;

      > div > div > div > div > div > table > tbody > tr > td > div > button {
        background-color: #f0f0f0 !important;
        border-radius: 8px;
        padding: 0 8px;
        border: none;
        box-shadow: none;
        &:hover {
          svg {
            opacity: 0.7;
          }
        }
        svg {
          margin-top: -5px;
          color: #4c4c4c;
        }
      }
    }

    > div > .rankmiTable-container .ant-spin-container {
      margin-top: 0;
    }
  }

  .tox-tinymce {
    border-radius: 16px;
    padding: 16px;
    border: 2px solid #dcdcdc;
    .tox-menubar > button > span {
      color: #757575;
    }
    .tox-toolbar__primary {
      border-top: none !important;
      background: unset;
      > div {
        border-right-color: #dcdcdc !important;
        border-bottom: 1px solid #dcdcdc;
      }
      .tox-tbtn > span {
        color: #808080;
        font-weight: bold;
      }
      .tox-tbtn > span > svg {
        fill: #808080;
        path {
          fill: #808080;
        }
      }
      .tox-tbtn--disabled > span > svg {
        fill: #aaa9a9;
        path {
          fill: #aaa9a9;
        }
      }
    }
    .tox-toolbar-overlord {
      background-color: white !important;
    }
  }

  .ant-tabs-top-bar {
    display: none;
  }

  .rankmiTemplates-templateHeaderNode + div {
    margin-top: -5px;
    margin-bottom: -18px;
  }
`
